import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Возвращает значение скрола в начало страницы при навигации между страницами.
 * @param children
 * @constructor
 */
export const ScrollToTop = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return <>{children}</>;
};
